<template>
  <div>
    <a href="#/" class="btn btn-dark mb-2 text-nowrap" @click="showModal()">Request Changes</a>

    <b-modal id="request-changes-modal" hide-footer>
      <template #modal-title>Request Changes</template>

      <div class="row text-white">
        <div class="col">
            <label class="form-label pt-0 mb-0" for="dealer-name">Note</label>
            <div class="mb-2"><small>Please say what changes you would like</small></div>
            <textarea class="form-control shadow-none inputbox" rows="3" v-model="note"></textarea>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-danger submit col" @click="requestChanges">Request Changes</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
  props: ['project'],

  data() {
    return {
      note: null,
      updating: false,
      projectInfo: null,
    };
  },

  created() {
    
  },

  methods: {

    showModal() {
      this.$bvModal.show("request-changes-modal");
    },

    hideModal() {
      this.$bvModal.hide("request-changes-modal");
    },

    requestChanges() {

        if (!this.note) {this.sweetfire('Please say what changes you would like')}

        else {

          this.updating = true;

          axios.post('/projects/request-changes', {
            project_id: this.project.id, 
            note: this.note})
        .then((response) => {
          this.hideModal();
          this.updating = false;
          this.projectInfo = response.data;
          this.showToaster('Changes requested');
        });

        }

      },

      showToaster(text) {
      this.$toaster.success(text, { timeout: 2500 });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
select.form-select {
  background-color: #ffffff !important;
  border: 2px solid #35363a;
}

.input-group-text.price {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding-left: 1.0rem;
}

input.form-control.price {
    padding-left: 0rem;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-top-right-radius: 5px !important;
    border-bottom-right-radius: 5px !important;
    }

.btn.btn-success.submit, .btn.btn-danger.submit, .btn.btn-secondary.submit {
    border-radius: 5px !important;
}
</style>